import { render } from "./SecondaryButton.vue?vue&type=template&id=65b2b92e&scoped=true&ts=true&lang=pug"
import script from "./SecondaryButton.vue?vue&type=script&lang=ts"
export * from "./SecondaryButton.vue?vue&type=script&lang=ts"

import "./SecondaryButton.vue?vue&type=style&index=0&id=65b2b92e&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b2b92e"]])

export default __exports__